import * as yup from 'yup';
import {
  CheckboxSchema,
  CheckboxWithOptionalTextSchema,
  CheckboxWithTextNumberSchema,
  ICheckbox,
  ICheckboxWithText,
  ICheckboxWithTextNumber,
} from '../../../common';
import { FixationFrequency } from '../../../enums';

export const CarePlan1Schema = yup.object({
  needsAssistance: yup
    .object({
      selected: yup.boolean().optional().default(false),
      value: yup.array(yup.string().notRequired()).nullable().default([]),
    })
    .notRequired()
    .nullable()
    .default({}),
  plan: yup.array().nullable().default([]),
  completeImmobility: CheckboxSchema.notRequired().nullable().default({}),
  movementAids: yup.string().notRequired().nullable(),
  fallRisk: CheckboxSchema.notRequired().nullable().default({}),
  decubitusRisk: CheckboxSchema.notRequired().nullable().default({}),
  contractureRisk: CheckboxSchema.notRequired().nullable().default({}),
  lowResilience: yup.string().notRequired().nullable(),
  additionalInfo: yup.string().notRequired().nullable(),
  goals: yup.string().notRequired().nullable(),
  sturdyShoes: CheckboxSchema.notRequired().nullable().default({}),
  exercises: CheckboxWithTextNumberSchema.notRequired().nullable().default({}),
  accompaniment: yup.string().notRequired().nullable(),
  visualInspectionFrequency: yup.number().notRequired().nullable(),
  provideAids: CheckboxSchema.notRequired().nullable().default({}),
  provideProtectors: CheckboxWithOptionalTextSchema.notRequired().nullable().default({}),
  bedSidePanel: CheckboxSchema.notRequired().nullable().default({}),
  bedLower: CheckboxSchema.notRequired().nullable().default({}),
  bedMattress: CheckboxSchema.notRequired().nullable().default({}),
  contactMat: CheckboxSchema.notRequired().nullable().default({}),
  fixation: yup
    .object({
      selected: yup.boolean().default(false),
      value: yup.mixed().when('selected', {
        is: true,
        then: yup
          .array(
            yup
              .object({
                type: yup.string().required(),
                text: yup.string().notRequired().nullable(),
                valid: yup.string().notRequired().nullable(),
                showAlert: CheckboxWithTextNumberSchema.notRequired().nullable().default({}),
                ownWish: CheckboxSchema.notRequired().nullable().default({}),
                frequency: yup
                  .mixed()
                  .oneOf(['DAILY', 'IF_REQUIRED', null])
                  .notRequired()
                  .nullable(),
                checkFrequency: yup.number().notRequired().nullable(),
              })
              .notRequired()
              .nullable()
              .default({}),
          )
          .notRequired()
          .nullable()
          .default([]),
      }),
    })
    .notRequired()
    .nullable()
    .default({}),
  beddingMethod: yup.string().notRequired().nullable(),
  aids: yup.string().notRequired().nullable(),
  pressureReliefMethod: yup.string().notRequired().nullable(),
  skinInspection: CheckboxWithOptionalTextSchema.notRequired().nullable().default({}),
  pneumoniaProphylaxis: CheckboxWithOptionalTextSchema.notRequired().nullable().default({}),
  thrombosisProphylaxis: CheckboxWithOptionalTextSchema.notRequired().nullable().default({}),
  other: yup.string().notRequired().nullable(),
});

export interface ITimes {
  hour?: number;
  first?: boolean;
  last?: boolean;
}

export interface IPlanItem {
  key?: string;
  title?: string;
  times?: ITimes[];
}

export interface IFixationCheckbox {
  selected: boolean;
  value?: IFixation[];
}

export interface IFixation {
  type?: string;
  text?: string;
  valid?: string;
  showAlert: ICheckboxWithTextNumber;
  ownWish: ICheckbox;
  frequency?: FixationFrequency;
  checkFrequency?: number;
}

export interface ICarePlan1 {
  needsAssistance: { selected: boolean; value: string[] };
  plan: IPlanItem[];
  completeImmobility: ICheckbox;
  movementAids?: string;
  fallRisk: ICheckbox;
  decubitusRisk: ICheckbox;
  contractureRisk: ICheckbox;
  lowResilience?: string;
  additionalInfo?: string;
  goals?: string;
  sturdyShoes: ICheckbox;
  exercises: ICheckboxWithTextNumber;
  accompaniment?: string;
  visualInspectionFrequency?: number;
  provideAids: ICheckbox;
  provideProtectors: ICheckboxWithText;
  bedSidePanel: ICheckbox;
  bedLower: ICheckbox;
  bedMattress: ICheckbox;
  contactMat: ICheckbox;
  fixation: IFixationCheckbox;
  beddingMethod?: string;
  aids?: string;
  pressureReliefMethod?: string;
  skinInspection: ICheckboxWithText;
  pneumoniaProphylaxis: ICheckboxWithText;
  thrombosisProphylaxis: ICheckboxWithText;
  other?: string;
}
